﻿<template>
	<div>
		<slot></slot>
	</div>
</template>

<script>
	import $ from "jquery";
	import Vue from "vue";
	import "slick";

	export default {
		props: {
			options: {
				type: Object,
				default: function () {
					return {};
				},
			},
			slideCount: Number
		},

		computed: {
			$slick: function () {
				return $(this.$el);
			}
		},

		mounted: function () {
			this.create();
		},

		destroyed: function () {
			this.$slick.ccsSlick('unslick');
		},

		watch: {
			slideCount: function () {
				this.updateSlideCount();
			}
		},

		methods: {
			create: function () {
				const $slick = this.$slick;

				$slick.on('afterChange', this.onAfterChange);
				$slick.on('beforeChange', this.onBeforeChange);
				$slick.on('breakpoint', this.onBreakpoint);
				$slick.on('destroy', this.onDestroy);
				$slick.on('edge', this.onEdge);
				$slick.on('init', this.onInit);
				$slick.on('reInit', this.onReInit);
				$slick.on('setPosition', this.onSetPosition);
				$slick.on('swipe', this.onSwipe);
				$slick.on('lazyLoaded', this.onLazyLoaded);
				$slick.on('lazyLoadError', this.onLazyLoadError);

				$slick.on('setPosition', this.postponeRefreshIfInvisible);

				$slick.ccsSlick(this.options);

				this.updateSlideCount();
			},

			destroy: function () {
				const $slick = this.$slick;

				$slick.off('afterChange', this.onAfterChange);
				$slick.off('beforeChange', this.onBeforeChange);
				$slick.off('breakpoint', this.onBreakpoint);
				$slick.off('destroy', this.onDestroy);
				$slick.off('edge', this.onEdge);
				$slick.off('init', this.onInit);
				$slick.off('reInit', this.onReInit);
				$slick.off('setPosition', this.onSetPosition);
				$slick.off('swipe', this.onSwipe);
				$slick.off('lazyLoaded', this.onLazyLoaded);
				$slick.off('lazyLoadError', this.onLazyLoadError);

				$slick.ccsSlick('unslick');
			},

			postponeRefreshIfInvisible: function () {
				const $slick = this.$slick;

				const updateWhenVisible = () => {
					clearTimeout(this.refreshTimeout);

					if ($slick.is(":visible")) {
						this.$nextTick(this.setPosition);
						return;
					}

					this.refreshTimeout = setTimeout(updateWhenVisible, 250);
				}

				if (!$slick.is(":visible")) {
					updateWhenVisible();
				}
			},

			updateSlideCount: function () {
				if (!this.slideCount) {
					return;
				}

				const currIndex = this.currentSlide();

				Vue.nextTick(() => {
					this.setOption("slidesToShow", this.slideCount);
					this.setOption("slidesToScroll", this.slideCount, true);

					this.goTo(currIndex, true);
				});
			},

			reInit: function () {
				const currIndex = this.currentSlide();
				this.destroy();

				this.$nextTick(() => {
					this.create()
					this.goTo(currIndex, true)
				})
			},

			next: function () {
				this.$slick.ccsSlick('slickNext');
			},

			prev: function () {
				this.$slick.ccsSlick('slickPrev');
			},

			pause: function () {
				this.$slick.ccsSlick('slickPause');
			},

			play: function () {
				this.$slick.ccsSlick('slickPlay');
			},

			goTo: function (index, dontAnimate) {
				this.$slick.ccsSlick('slickGoTo', index, dontAnimate);
			},

			currentSlide: function () {
				return this.$slick.ccsSlick('slickCurrentSlide');
			},

			add: function (element, index, addBefore) {
				this.$slick.ccsSlick('slickAdd', element, index, addBefore);
			},

			remove: function (index, removeBefore) {
				this.$slick.ccsSlick('slickRemove', index, removeBefore);
			},

			filter: function (filterData) {
				this.$slick.ccsSlick('slickFilter', filterData);
			},

			unfilter: function () {
				this.$slick.ccsSlick('slickUnfilter');
			},

			getOption: function (option) {
				this.$slick.ccsSlick('slickGetOption', option);
			},

			setOption: function (option, value, refresh) {
				this.$slick.ccsSlick('slickSetOption', option, value, refresh);
			},

			setPosition: function () {
				this.$slick.ccsSlick('setPosition');
			},

			// Events
			onAfterChange: function (event, slick, currentSlide) {
				this.$emit('afterChange', event, slick, currentSlide);
			},

			onBeforeChange: function (event, slick, currentSlide, nextSlide) {
				this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
			},

			onBreakpoint: function (event, slick, breakpoint) {
				this.$emit('breakpoint', event, slick, breakpoint);
			},

			onDestroy: function (event, slick) {
				this.$emit('destroy', event, slick);
			},

			onEdge: function (event, slick, direction) {
				this.$emit('edge', event, slick, direction);
			},

			onInit: function (event, slick) {
				this.$emit('init', event, slick);
			},

			onReInit: function (event, slick) {
				this.$emit('reInit', event, slick);
			},

			onSetPosition: function (event, slick) {
				this.$emit('setPosition', event, slick);
			},

			onSwipe: function (event, slick, direction) {
				this.$emit('swipe', event, slick, direction);
			},

			onLazyLoaded: function (event, slick, image, imageSource) {
				this.$emit('lazyLoaded', event, slick, image, imageSource);
			},

			onLazyLoadError: function (event, slick, image, imageSource) {
				this.$emit('lazyLoadError', event, slick, image, imageSource);
			},
		}
	};
</script>
